<template lang="pug">
v-card(:class="classes")
  v-divider.ma-1
  v-layout.pl-5.pr-5(row, no-gutters, wrap, text-center, align-center)
    v-menu(
      offset-y,
      nudge-bottom="10",
      v-for="(filter, index) in filterProps.items",
      :key="filter.text",
      :close-on-content-click="false",
      transition="slide-y-transition"
    )
      template(v-slot:activator="{ on, attrs }")
        v-chip.ml-1(
          v-bind="attrs",
          v-on="on",
          :color="getChipColor(filter.text)",
          @click="selectChip(filter.text)"
        ) {{ filter.text }}

      v-card(:width="cardWidth(filter.headers)")
        .row.no-gutters.wrap.text-center.align-center
          //- Caso seja select e multiple
          v-autocomplete.py-2(
            ref="autocomplete",
            v-model="filter.selecteds",
            v-if="filter.type === 'select'",
            :items="filter.values",
            item-text="text",
            item.value="value",
            label="Selecione",
            hide-details,
            rounded,
            :dense="filter.multiple && filter.headers !== undefined ? true : false",
            return-object,
            :single-line="!filter.multiple",
            :multiple="filter.multiple",
            @change="addFilter",
            clearable
          )
            template(v-slot:selection="{ item: selectedItem, index }")
              template(v-if="index === 0")
                span {{ selectedItem.text.substring(0, 25) }}{{ selectedItem.text.length > 25 ? "..." : "" }}
                span.grey--text.text-caption(
                  v-if="filter.selecteds && filter.selecteds.length > 1"
                )
                  | ({{ filter.selecteds.length }} selecionados)

            template(
              v-slot:prepend-item,
              v-if="filter.multiple && filter.headers"
            )
              v-row.no-gutters.align-center.pa-0.ma-0.pl-4.pt-2.pb-2(
                style="background-color: #f5f5f5; border-bottom: 1px solid #e0e0e0; padding: 8px 16px"
              )
                .pa-0.ma-0.mt-2.mb-2.text-caption(style="width: 48px")

                .pa-0.ma-0.pl-1.pr-1.text-caption(
                  v-for="(header, index) in filter.headers",
                  :key="index",
                  :style="getColumnStyle(header.width)"
                )
                  span.font-weight-medium {{ header.value }}

            template.pa-0.ma-0(
              v-slot:item="{ item: menuItem, selected }",
              v-if="filter.multiple && filter.headers"
            )
              v-row.no-gutters.align-center.pa-0.ma-0(
                style="border-bottom: 1px solid #e0e0e0; padding: 8px 16px",
                @click="menuItem.selected = !menuItem.selected"
              )
                template(v-if="menuItem.moreFields")
                  .pa-0.ma-0.text-caption(style="width: 48px")
                    v-checkbox(
                      v-model="menuItem.selected",
                      :input-value="menuItem.selected",
                      hide-details,
                      dense,
                      @click="menuItem.selected = !menuItem.selected"
                    )

                  .pa-0.ma-0.pl-1.pr-1.text-caption(
                    v-for="(header, index) in filter.headers",
                    :key="index",
                    :style="getColumnStyle(header.width)"
                  )
                    span {{ menuItem.moreFields[header.field] }}

          //- Caso seja componente de seleção de data
          .row.no-gutters.wrap.text-center.align-center.px-2(
            v-else-if="filter.type === 'date' || filter.type === 'datetime'"
          )
            v-text-field.mr-2(
              :type="filter.type == 'date' ? 'date' : 'datetime-local'",
              hide-details,
              dense,
              v-model="filter.value",
              :label="filter.text",
              :max="filter.date_max",
              :min="filter.date_min",
              @change="addFilter(filter)"
            )
            v-btn(small, icon, color="success", @click="addFilter(filter)")
              v-icon(small) fa-check
            v-btn(small, icon, color="error", @click="addFilter()")
              v-icon(small) fa-close

    v-spacer

    v-text-field.md-3.mr-1(
      v-if="filterProps.includeSearch",
      v-model="filterProps.searchText",
      clearable,
      color="primary",
      dense,
      outlined,
      prepend-inner-icon="mdi-magnify",
      label="Buscar",
      hide-details
    )
    slot(name="actions")

  v-divider.ma-1
  v-data-iterator(
    :items="getItems",
    :search="filterProps.searchText",
    v-bind="searchFilter ? { customFilter: searchFilter } : {}",
    :disable-pagination="paginate == false",
    :items-per-page.sync="itemsPerPage",
    :page.sync="page",
    :no-data-text="'Nenhum registro encontrado'",
    :no-results-text="'Nenhum registro encontrado'",
    hide-default-footer
  )
    template(v-slot:no-data)
      slot(v-if="renderEmpty", :items="[]", :page="page")
      div(v-else) Nenhum registro encontrado

    template(v-slot:no-results)
      slot(v-if="renderEmpty", :items="[]", :page="page")
      v-card.elevation-0.pa-15(v-else)
        v-row(align="center", justify="center")
          div Nenhum registro encontrado

    template(v-slot:default="{ items }")
      slot(:items="items", :page="page")

    template(v-slot:footer)
      v-divider
      v-row.align-center.justify-end(v-if="paginate", no-gutters)
        slot(name="footer")
        v-spacer
        h5.pt-1 Itens por página:
        v-select.mx-5.pt-6(
          dense,
          outlined,
          style="max-width: 120px",
          v-model="itemsPerPage",
          :items="paginationOptions"
        )
        h5.pt-1.mr-5 {{ getDescItemsPaginados() }}

        v-pagination(
          circle,
          v-model="page",
          :length="itemsCountPages()",
          :total-visible="7"
        )
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    filterProps: {
      type: Object,
      required: false,
      default: () => ({
        items: [],
        includeSearch: true,
        searchText: "",
        useSearchHash: false,
      }),
    },
    paginate: {
      type: Boolean,
      required: false,
      default: true,
    },
    renderEmpty: {
      type: Boolean,
      default: false,
    },
    searchFilter: {
      type: Function,
      default: null,
    },
    paginationOptions: {
      type: Array,
      required: false,
      default: () => [15, 30, 100, { text: "Todos", value: -1 }],
    },
    classes: {
      type: String,
      required: false,
      default: "elevation-2",
    },
  },

  data: () => ({
    filteredItems: [],
    filters: [],
    selectedChip: null,
    search: "",
    page: 1,
    itemsPerPage: 15,
  }),

  methods: {
    emitEvent(event) {
      this.$emit(event);
    },

    getColumnStyle(width) {
      return `width: ${width}px; padding: 0 8px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;`;
    },

    getChipColor(field) {
      const filter = this.filters.filter((item) => item.chip === field);

      return filter.length > 0 ? "primary" : "";
    },

    cardWidth(headers) {
      if (headers?.length) {
        const totalHeadersWidth = headers?.reduce((sum, header) => {
          const width = parseInt(header.width) || 0;
          return sum + width;
        }, 0);
        return `${totalHeadersWidth + 100}px`;
      }
      return "350px";
    },

    selectChip(field) {
      this.selectedChip = field;
    },

    selectAllItems(value) {
      if (value) {
        this.$refs.autocomplete.selectAll();
      } else {
        this.$refs.autocomplete.deselectAll();
      }
    },

    addFilter(filter) {
      this.deleteFilter(this.selectedChip);

      if (filter) {
        if (Array.isArray(filter)) {
          if (filter.length > 0) {
            this.filters.push({ chip: this.selectedChip, filter });
          }
        } else {
          this.filters.push({ chip: this.selectedChip, filter });
        }
      }

      this.applyFilters();
    },

    deleteFilter(field) {
      this.filters.map((item, index) => {
        if (item.chip == field) {
          this.filters.splice(index, 1);
        }
      });
    },

    applyFilters() {
      if (this.$listeners.filterApplied) {
        this.filteredItems = this.items;
        this.itemsCountPages();
        this.$emit('filterApplied', this.filters);
        return;
      }

      if (this.filters && this.filters.length == 0) {
        this.filteredItems = this.items;
        this.itemsCountPages();
        this.$emit('filterApplied', []);
        return;
      }

      this.filteredItems = this.items.filter((item) => {
        let result = false;

        for (const { filter } of this.filters) {
          if (Array.isArray(filter)) {
            result = filter.some((f) => {
              if (f.fn) {
                return f.fn([item, f]);
              }

              return item[f.field] === f.value;
            });
          } else if (filter.fn) {
            result = filter.fn([item, filter]);
          } else {
            result = item[filter.field] === filter.value;
          }

          if (!result) {
            break;
          }
        }

        return result;
      });
      
      this.$emit('filterApplied', this.filters);
    },

    itemsCountPages() {
      const items =
        this.filteredItems.length > 0 ? this.filteredItems : this.items;

      let pages = Math.round(items.length / this.itemsPerPage);
      if (!pages) {
        pages = 0;
      }

      if (pages * this.itemsPerPage < this.filteredItems.length) {
        pages++;
      }

      return pages;
    },

    getDescItemsPaginados() {
      const finalItems = this.page * this.itemsPerPage;
      const inicialItems = finalItems - this.itemsPerPage + 1;
      const totalItems = this.filteredItems.length;

      return `${totalItems > 0 ? inicialItems : 0} - ${
        totalItems < finalItems ? totalItems : finalItems
      } / ${totalItems}`;
    },
  },

  watch: {
    "filterProps.searchText"() {
      if (this.filterProps.useSearchHash) {
        window.location.hash = this.filterProps.searchText ?? "";
      }
    },
  },

  computed: {
    getItems() {
      if (this.$listeners.filterApplied) {
        this.filteredItems = this.items;
        return this.items;
      }
      
      const items = this.filters.length > 0 ? this.filteredItems : this.items;
      this.filteredItems = items;
      return items;
    },
  },
};
</script>
